import { checkRules } from '../../../utils/ValidateRules';

const validateRules = (formValues, itemProperties) => (value, allValues) => {
    let message = checkRules(allValues.toJS(), itemProperties,value);
    console.log(message, value)
    return message ? message : undefined;
    return undefined;
}

export default validateRules;